import React from "react";
import useImageSliderIndex, {
    sizeMap,
    SliderIndex,
} from "../../../../../../common-deprecated/hooks/useImageSliderIndex";
import * as Styles from "../styles/ImageSliderIndex";

type ImageSliderIndexType = { itemCount: number; activeItemIndex: number; invertedColour?: boolean };

/**
 * Render an image "slider index", which is a list of circles indicating where the user is in the image slider.
 *
 * This component uses an array of Slider Indexes for rendering the slider.
 * For example: [empty, empty, small, active, large, large] should render " | . o Ø O O | "
 * With some effect and array calculation wizardry we calculate how the circles are positioned and which transition should happen.
 *
 * @param itemCount - Total amount of items (images) in the slider.
 * @param activeItemIndex - Zero based index of the currently active item (image).
 */
const ImageSliderIndex = ({ itemCount, activeItemIndex, invertedColour }: ImageSliderIndexType): JSX.Element => {
    const { sliderArray } = useImageSliderIndex(itemCount, activeItemIndex);

    return (
        <Styles.CircleContainer totalItems={itemCount}>
            <Styles.CircleTrack>
                {sliderArray.map((sliderIndex, index) => (
                    // Keeping the index as a key is important here as this will not rerender the complete component.
                    // However the styles will update which is what we want as that will trigger the CSS animations.
                    <Styles.Circle
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        active={sliderIndex === SliderIndex.Active}
                        size={sizeMap[sliderIndex]}
                        invertedColour={!!invertedColour}
                    />
                ))}
            </Styles.CircleTrack>
        </Styles.CircleContainer>
    );
};

export default ImageSliderIndex;
